import PouchDB from 'pouchdb';
import * as sync from '../syncer';

import db from '@/store/db';
import bcrypt from 'bcryptjs';
import log from '@/logger';

export default {
  login: function (state, dispatch, credentials) {
    const pouchOpts = {
      skip_setup: true,
      skipSetup: true,
    };

    credentials.username = credentials.username.toLowerCase();
    credentials.password = credentials.password.trim();

    const dbProps = db.DB('organisation', credentials.username);
    dbProps.username = credentials.username;
    dbProps.password = credentials.password;
    db.loggedInUsername = credentials.username;
    db.loggedInPassword = credentials.password;

    const rootDbProps = db.DB();
    const url = new URL(rootDbProps.localDb, rootDbProps.baseUrl);
    const dbUser = new PouchDB(url.toString(), pouchOpts);
    let loggedInUser;

    return dbUser
      .login(credentials.username, credentials.password)
      .then(async (user) => {
        user.username = credentials.username;
        user.password = bcrypt.hashSync(credentials.password, 10);
        loggedInUser = user;

        db.organisationLogDb = await db.init('organisation-log');
        await db.initLogViews(db.organisationLogDb);
        sync.replicate(credentials, db.organisationLogDb, db.DB('organisation-log'));

        db.organisationDb = await db.init('organisation');
        await db.initViews(db.organisationDb);

        db.userDb = await db.init('comments-' + user.username);
        const userDbProps = db.DB('comments-' + user.username);
        userDbProps.username = credentials.username;
        userDbProps.password = credentials.password;

        sync.initSync(db.userDb, state, dispatch, userDbProps);
        await db.initViews(db.userDb);
      })
      .then(() => {
        return sync.initSync(db.organisationDb, state, dispatch, dbProps);
      })
      .then(() => {
        log.debug('userApi::login, logged in');
        return loggedInUser;
      })
      .catch((error) => {
        if (error.status === 0 && state.user.password) {
          var validPassword = bcrypt.compareSync(credentials.password, state.user.password);
          if (credentials.username === state.user.username && validPassword) {
            return state.user;
          }
        }
        log.error('userApi::login, login error', error);
        throw error;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/user/userApi.js